import { useSelector } from 'react-redux'
import { State } from 'src/state'
import Button from 'src/global/Button'
import Setting from '../Setting'

export default function LanguageSetting() {
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const openLanguageModal = () => {
    window.hideSettingsModal()
    setTimeout(() => {
      window.openLanguageModal()
    }, 0)
  }

  return (
    <>
      <Setting
        title="Limbi Meniu"
        iconPath="/icons/languages.png"
        rightButton={
          <Button
            variant="as-text"
            text="Alege..."
            onClick={openLanguageModal}
            style={{ marginTop: 0, padding: 0, paddingRight: 8 }}
          />
        }
        infoText={`Limbi curente: ${user.menuLanguages?.join(', ')}.`}
      />
    </>
  )
}
